import { useGlobalState } from "AppStore";
import LoadingOverlay from "components/basic/LoadingOverlay";
import { Dashboard, Page } from "model/Datatypes";
import React from "react";
import DashboardMenuButton from "resources/icons/DashboardMenuButton";

type Props = {
  dashboard: Dashboard;
  currentPage: Page;
  handlePageChange: (page: Page) => void;
  handleAnimationDirection: (direction: "left" | "right") => void;
};

const Menu = ({
  dashboard,
  currentPage,
  handlePageChange,
  handleAnimationDirection,
}: Props) => {
  const { type } = useGlobalState();

  return (
    <div
      className={`${
        type === "WIDE" ? "2xl:mr-20" : "w-full h-20 2xl:h-40"
      }  place-self-center`}
    >
      <div
        className={`flex h-full ${
          type === "WIDE"
            ? "flex-col justify-center items-center"
            : "place-content-center justify-center content-center"
        }`}
      >
        {dashboard ? (
          dashboard.pages.map((page, i) => {
            return (
              <DashboardMenuButton
                key={page.id}
                active={page.id === currentPage?.id}
                icon={page.dashIcon}
                onClick={() => {
                  const animationDirection =
                    i > dashboard.pages.indexOf(currentPage!) ? "right" : "left";
                  handleAnimationDirection(animationDirection);
                  setTimeout(() => {
                    handlePageChange(page);
                  }, 100);
                }}
              />
            );
          })
        ) : (
          <LoadingOverlay />
        )}
      </div>
    </div>
  );
};

export default Menu;
